import React, { createContext, useState, useRef, useContext } from "react";
import { AuthService } from "../../services/auth/auth.service";
import { IdleTimerProvider } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/Auth/AuthContext";
import { useCreditStore } from "../../store/creditStore/creditUserStore";
import { userBankStore } from "../../store/creditStore/userBankStore";
import { stepsCreditStore } from "../../store/creditStore/stepsCreditStore";
import { creditOfferStore } from "../../store/creditStore/offerCreditStore";
import DialogComponent from "../../components/new_components/dialogo";
import { useMobileDetection } from "../../hooks/use-mobile-detection";

const InactivityContext = createContext();

const InactivityProvider = ({ children }) => {
  const { isDesktop } = useMobileDetection();

  const [showModal, setShowModal] = useState(false);
  const [countdown, setCountdown] = useState(180); // 3 minutos en segundos
  const countdownRef = useRef(null);
  const { updateAlertSignIn } = useContext(AuthContext);

  const navigate = useNavigate();

  const onIdle = () => {
    setShowModal(true);
    startCountdown();
  };

  const handleModalClose = () => {
    resetTimer();
  };

  const cleanIndexDB = () => {
    // Solo se necesita llamar estas acciones al expirar la sesion, no
    // suscribirse reactivamente al estado de las 4 stores -- se leen via
    // ".getState()" (sin hooks) en vez de "useXStore()" (con hooks). Ver
    // docs/UPGRADE-CORE-GALILEA.md, fase 7bis: usar las 4 versiones
    // reactivas encadenadas en el mismo componente disparaba 4
    // "useSyncExternalStore" seguidos, y bajo ciertas condiciones de
    // temporizacion (una de las stores recibe un "set()" de otro
    // consumidor justo despues del commit inicial) React fuerza un
    // re-render sincrono para evitar "tearing" que terminaba con un
    // conteo de hooks distinto al de la primera renderizacion --
    // "Should have a queue. You are likely calling Hooks conditionally".
    useCreditStore.getState().clearUser();
    userBankStore.getState().clearUserBank();
    creditOfferStore.getState().clearOfertCredit();
    stepsCreditStore.getState().clearSteps();
    localStorage.clear();
  };

  const startCountdown = () => {
    countdownRef.current = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(countdownRef.current);

          //cerrar sesión logout y enviar a login
          AuthService.logout({
            documento: localStorage.getItem("doc"),
            otp: localStorage.getItem("token"),
          })
            .then(() => {
              updateAlertSignIn({
                message:
                  "Su sesión ha sido expirada, por favor inicie sesión nuevamente.",
                show: true,
                title: "Sesión expirada",
              });
              cleanIndexDB();
              navigate("/");
              return 0;
            })
            .catch((e) => console.log(e));
        }
        return prev - 1;
      });
    }, 1000);
  };

  const resetTimer = () => {
    setShowModal(false);
    setCountdown(180);
    clearInterval(countdownRef.current);
  };

  return (
    <IdleTimerProvider
      timeout={300000} // 5 minutos
      onIdle={onIdle}
      debounce={250}
    >
      <InactivityContext.Provider value={{ resetTimer }}>
        {children}
        <DialogComponent
          open={showModal}
          onOpenChange={setShowModal}
          title="¿Sigues ahí?"
          description={`Tu sesión se cerrará en ${Math.floor(countdown / 60)}: ${countdown % 60 < 10 ? "0" + (countdown % 60) : countdown % 60}`}
          showAcceptButton={true}
          acceptText="Sigo aquí"
          onAccept={() => {
            handleModalClose();
          }}
          isLoadingAccept={false}
          disableAccept={false}
          disableBackdropClose={true}
          showCloseButton={true}
          isDesktop={isDesktop}
        />

        {/* <InactivityModal
          isOpen={showModal}
          title={`¿Sigues ahí?`}
          messageTitle={`Tu sesión se cerrará en ${Math.floor(countdown / 60)}: ${countdown % 60 < 10 ? "0" + (countdown % 60) : countdown % 60}`}
          msgPrimary={`Sigo Aquí!`}
          action={handleModalClose}
          onHide={() => {}}
        /> */}
      </InactivityContext.Provider>
    </IdleTimerProvider>
  );
};

export { InactivityProvider, InactivityContext };
